import { Configuration, FrontendApi } from '@ory/client';
import { getAuthUrl } from 'utils/config';
export default new FrontendApi(new Configuration({
    baseOptions: {
        withCredentials: true,
    },
    basePath: getAuthUrl(),
}));
